<template>
    <div class="container-fluid crm_dashboard">
        <div class="row widget-grid">
            <breadCrumbs main="Dashboard" titles="CRM Dashboard" title="CRM Dashboard" />
            <transactionHistory />
            <topCustomer />
            <allNotification />
            <balanceOverview />
            <salesAnalyics />
            <dealOpen />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const transactionHistory = defineAsyncComponent(() => import("@/components/theme/dashboards/crm/transactionHistory.vue"))
const topCustomer = defineAsyncComponent(() => import("@/components/theme/dashboards/crm/topCustomer.vue"))
const allNotification = defineAsyncComponent(() => import("@/components/theme/dashboards/crm/allNotification.vue"))
const balanceOverview = defineAsyncComponent(() => import("@/components/theme/dashboards/crm/balanceOverview.vue"))
const salesAnalyics = defineAsyncComponent(() => import("@/components/theme/dashboards/crm/salesAnalyics.vue"))
const dealOpen = defineAsyncComponent(() => import("@/components/theme/dashboards/crm/dealOpen.vue"))
</script>